import { _breakP } from './utils.js';
export default class common {
  constructor() {
    this.smoothScroll();
    this.scrollAnimation();
    this.headerFunc();
    this.popupFunc();
  }

  // commonFunc(TOPページの関数)
  smoothScroll() {
    const smoothScrollTriggers = document.querySelectorAll('a[href^="#"]');
    smoothScrollTriggers.forEach(function(smoothScrollTrigger) {
      smoothScrollTrigger.addEventListener('click', function(e) {
        const href = smoothScrollTrigger.getAttribute('href');
        const targetElement = document.getElementById(href.replace('#', ''));
        const adjust = document.getElementById('gHeader').clientHeight;
        if (targetElement) {
          e.preventDefault();
          e.stopPropagation();
          if (window.__lenis && !window.__lenis.isStopped) {
            window.__lenis.scrollTo(targetElement, { offset: -adjust });
          } else {
            const targetPosition = window.pageYOffset + targetElement.getBoundingClientRect().top - adjust;
            window.scrollTo({ top: targetPosition, behavior: 'smooth' });
          }
        }
      });
    });
  }
  scrollAnimation() {
    const $target = document.querySelectorAll('[data-sai]');
    for (let i = 0; i < $target.length; i++) {
      const targetEach = $target[i];
      targetEach.classList.add('sai-init');
    }
    window.addEventListener(
      'load',
      function() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        for (let i = 0; i < $target.length; i++) {
          const targetEach = $target[i],
            rect = targetEach.getBoundingClientRect(),
            targetPosition = scrollTop + rect.top;
          if (targetPosition < scrollTop) {
            targetEach.classList.add('sai-animate');
          }
        }
      },
      false
    );
    const options = {
      offset: 150,
      delay: 0,
      easing: 'ease',
      duration: 1500,
      disable: false,
      once: false
    };

    document.querySelector('body').setAttribute('data-sai-easing', options.easing);
    document.querySelector('body').setAttribute('data-sai-duration', options.duration);
    document.querySelector('body').setAttribute('data-sai-delay', options.delay);

    const callback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('sai-animate');
          observer.unobserve(entry.target);
        }
      });
    };

    const option = { rootMargin: -options.offset + 'px 0px' };
    const io = new IntersectionObserver(callback, option);
    const targets = document.querySelectorAll('.sai-init');
    targets.forEach(target => {
      io.observe(target);
    });
  }

  headerFunc() {
    const $gHeader = _breakP.SP ? document.getElementById('spMenu') : document.getElementById('gHeader'),
      $container = document.querySelector('.container');

    if ($gHeader && $container) {
      $container.style.paddingTop = $gHeader.clientHeight + 'px';
    }
  }
  popupFunc() {
    const $popup = document.querySelectorAll('.js-popup');
    $popup.forEach(elm => {
      elm.addEventListener('click', e => {
        e.preventDefault();
        const options = 'scrollbars=yes,resizable=yes,width=950,height=800';
        const url = elm.getAttribute('href');
        window.open(url, 'null', options);
      });
    });
  }
}
